import ko from 'knockout';
import _ from 'underscore';
import {isFieldEditing} from '@bingads-webui-component-legacy/form/service/status';

export default function collapse(local, attrs, custom, viewModel) {
  if (_.isUndefined(custom.isExpanded)) {
    local.isExpanded = isFieldEditing(custom, viewModel);
  } else {
    local.isExpanded = custom.isExpanded;
  }
  local.observable = ko.observable(local.isExpanded);

  local.click = () => {
    let value = local.observable();

    local.observable(!value);
    return null;
  };

  _.extend(local, custom);
}
